import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgCleanserMoisturizerDuoGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M23 8H11v1.695l2.32 24.922v3.788l.1.1C14.025 39.7 15.64 40 17.05 40h.404c1.613-.1 2.823-.598 3.227-1.495l.1-.1v-4.087L23 9.994V8Zm-5.647 30.804c-1.21.1-2.42-.2-2.824-.698v-2.193c.706.299 1.715.498 2.521.498h.404c.806 0 1.512-.2 2.017-.498v2.093c-.202.399-1.009.698-2.118.798Zm2.118-4.586v.2c-.202.299-1.009.697-2.118.697-1.21.1-2.42-.2-2.824-.797L12.21 9.994v-.798h9.48v.499l-2.22 24.523ZM38 10.224C37.902 8.677 34.878 8 32.049 8c-2.83 0-5.951.677-6.049 2.224v27.36c0 1.546 3.122 2.32 6.049 2.32 2.927 0 6.049-.677 6.049-2.32v-20.4L38 10.224c0 .096 0 0 0 0Zm-10.732 0c.293-.29 1.854-1.064 4.78-1.064 2.83 0 4.391.677 4.781 1.064l.098.096c0 .097-.39.29-.878.484-.878.29-2.244.58-4 .58-1.854 0-3.122-.29-3.903-.58-.585-.194-.878-.387-.878-.58 0 .096 0 0 0 0Zm9.561 6.96c-.097.29-1.658 1.064-4.78 1.064-3.122 0-4.683-.774-4.78-1.064V11.77c1.17.58 3.024.87 4.78.87 1.756 0 3.61-.29 4.78-.87v5.414Zm-4.78 21.56c-3.122 0-4.683-.774-4.78-1.064V18.73c1.17.58 3.024.87 4.78.87 1.756 0 3.61-.29 4.78-.87V37.68c-.097.29-1.658 1.063-4.78 1.063Z",
    fill: "currentColor"
  }));
}

export { SvgCleanserMoisturizerDuoGlyph as default };
